/**
 * Coach UI store (Zustand) — minimal UI selection state only.
 *
 * ALL data is now fetched and mutated via React Query hooks:
 *   WorkoutTemplates  → useWorkoutTemplates()   (src/hooks/useWorkoutTemplates.ts)
 *   PlanTemplates     → usePlanTemplates()       (src/hooks/usePlanTemplates.ts)
 *   PlanInstances     → usePlanInstances()       (src/hooks/usePlanInstances.ts)
 *   KnowledgeEntries  → useKnowledgeEntries()    (src/hooks/useKnowledge.ts)
 *   WeekTemplates     → useWeekTemplates()       (src/hooks/useWeekTemplates.ts)
 *   CoachAthletes     → useCoachAthletes()       (src/hooks/useCoachAthletes.ts)
 */

import { create } from 'zustand';

interface CoachStore {
  selectedPlanTemplateId: string | null;
  selectedPlanInstanceId: string | null;
  selectPlanTemplate: (id: string) => void;
  selectPlanInstance: (id: string) => void;
}

export const useCoachStore = create<CoachStore>((set) => ({
  selectedPlanTemplateId: null,
  selectedPlanInstanceId: null,
  selectPlanTemplate: (id) => set({ selectedPlanTemplateId: id }),
  selectPlanInstance: (id) => set({ selectedPlanInstanceId: id }),
}));
